import { Stack } from '@mantine/core';

import { SectionLabel, SectionValue } from 'components';
import classes from './index.module.css';

interface ICard {
  label?: string;
  value?: string;
  children?: string | number | React.ReactNode;
}

const Card = ({
  value,
  label,
  children
}: ICard) => {
  return (
    <Stack className={classes.card} justify='center'>
      {value && <SectionValue value={value} />}
      {label && <SectionLabel label={label} />}
      {children}
    </Stack>
  );
}

export default Card;